import { useRef, useState } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { useSelector } from 'react-redux';

import * as IssuesV2Store from '../../../../redux/issuesV2';
import { Icon, icons } from '../../../generic';
import Tooltip from '../../../generic/Tooltip';

import styles from './IssueDetailsDrawer.module.less';

type TooltipText = 'Copy link' | 'Link copied';

/**
 * A component that displays an icon allowing users to copy the issue details link to their clipboard.
 */
const ShareLink = () => {
  const [tooltip, setTooltip] = useState<TooltipText>('Copy link');
  const issueDetailsURL = useSelector(IssuesV2Store.selectors.getIssueDetailsURLFromActiveIssueDetails);
  const buttonRef = useRef<HTMLButtonElement | null>(null);

  return (
    <Tooltip
      id="share-link"
      tooltip={tooltip}
      placement="bottom"
      onExited={() => {
        setTooltip('Copy link');
        if (buttonRef.current) {
          // Reset the focus on the button to prevent unintended tooltip display upon returning to the tab.
          buttonRef.current.blur();
        }
      }}>
      <CopyToClipboard text={issueDetailsURL}>
        <button
          ref={buttonRef}
          type="button"
          className={styles.shareLinkButton}
          onClick={() => {
            setTooltip('Link copied');
          }}
        >
          <Icon icon={icons.link} />
        </button>
      </CopyToClipboard>
    </Tooltip>
  );
};

export default ShareLink;
